import React from "react";
import HeartSvg from "../../../icons/HeartSvg";
import { cn } from "../../lib/utils";
interface BlogsMenuCardProps {
  className?: string;
  tag?: string;
  textContent?: string;
  blogDate?: string;
  imageLink?: string;
  blogLink?: string;
}

import { Button } from "../ui/button";

export const BlogsMenuCard = ({
  className,
  tag,
  textContent,
  blogDate,
  imageLink,
  blogLink,
}: BlogsMenuCardProps) => {
  return (
    <a
      href={blogLink}
      className={`space-y-4 ${className}`}
      // className={`bg-white w-full min-w-[320px] lg:min-w-0 hover:shadow-lg hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out`}
    >
      {/* IMAGE part */}
      <div className="flex w-full h-[372px] clip-path-webClipPolygonTopLeft">
        <img className="w-full h-full object-cover" src={imageLink} alt="" />
      </div>

      {/* Blogs Data */}
      <div className="items-center flex  w-full   rounded-tr-lg rounded-br-lg">
        <p className="text-brand-bgBlack capitalize pl-2 pr-6 py-[5px] lg:leading-5 text-[11px] leading-[15px] lg:text-web-body-md font-semibold font-openSans bg-brand-lightBlue clip-path-topRightFourSidedBlogs">
          {tag}
        </p>
        <p className="text-brand-textLightGrey ml-auto text-web-body-md font-normal font-openSans leading-[18px]">
          {blogDate}
        </p>
      </div>
      {/* Text */}
      <div className="">
        <p className="font-openSans capitalize font-normal text-mobile-body-md lg:text-web-body-lg leading-5 lg:leading-7 text-brand-textLightGrey">
          {textContent}
        </p>
      </div>
    </a>
  );
};
